import React, { useState } from "react";
import Header from "components/Headers/Header";
import {
  Col,
  Container,
  Row,
  Input,
  Label,
  Button,
  Form,
  FormGroup,
  Spinner,
  Card,
  CardBody,
  CardHeader
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updatePassword } from "store/actions/authActions";

function ChangePassword() {
  const { user, passwordLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.warning("Password length must be at least 6.");
    } else if (newPassword === currentPassword) {
      toast.warning("You are entering the same password.");
    } else if (newPassword !== confirmPassword) {
      toast.warning("New Passwords and confirm new password didn't match.");
    } else {
      let obj = {
        currentPassword: currentPassword,
        newPassword: newPassword,
      };
      dispatch(
        updatePassword(obj, () => {
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        })
      );
    }
  };

  const isSmallScreen = window.innerWidth < 768;

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Row className="d-flex align-items-stretch">
          {/* Left Column: Account Info Card */}
          <Col lg="5" className="mb-4">
            <Card className="shadow border-0 rounded-4 h-100 bg-white">
              <CardHeader className="bg-white border-0 pb-0 pt-4">
                <h3 className="mb-0 text-dark font-weight-700">
                  <i className="fas fa-user-circle text-primary mr-2"></i> Account Details
                </h3>
              </CardHeader>
              <CardBody className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-center mb-4">
                    <div 
                      className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto mb-3"
                      style={{ width: "80px", height: "80px", fontSize: "2rem", fontWeight: "bold" }}
                    >
                      {user?.first_name?.charAt(0)}{user?.last_name?.charAt(0)}
                    </div>
                    <h4 className="h3 text-dark font-weight-700 mb-1">
                      {user?.first_name} {user?.last_name}
                    </h4>
                    <span className="badge badge-pill badge-primary-light text-primary font-weight-700">
                      {user?.sport || "Athlete"} | {user?.state}
                    </span>
                  </div>

                  <div className="border-top pt-3 mt-3">
                    <div className="mb-3">
                      <small className="text-muted font-weight-600 d-block mb-1" style={{ fontSize: "0.8rem", letterSpacing: "0.5px" }}>
                        ATHLETE ID
                      </small>
                      <span className="text-dark font-weight-700" style={{ fontSize: "0.95rem" }}>
                        {user?.athleteID}
                      </span>
                    </div>
                    <div>
                      <small className="text-muted font-weight-600 d-block mb-1" style={{ fontSize: "0.8rem", letterSpacing: "0.5px" }}>
                        EMAIL ADDRESS
                      </small>
                      <span className="text-dark font-weight-700 text-break" style={{ fontSize: "0.95rem", wordBreak: "break-all" }}>
                        {user?.email}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-4 pt-3 border-top text-center text-muted" style={{ fontSize: "0.8rem" }}>
                  <i className="fas fa-lock mr-1"></i> Secure Connection Enabled
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Right Column: Change Password Card */}
          <Col lg="7" className="mb-4">
            <Card className="shadow border-0 rounded-4 h-100 bg-white">
              <CardHeader className="bg-white border-0 pb-0 pt-4">
                <h3 className="mb-0 text-dark font-weight-700">
                  <i className="fas fa-key text-success mr-2"></i> Update Password
                </h3>
              </CardHeader>
              <CardBody className="p-4">
                <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>
                  Enter your current password and your new password to securely update your account access credentials.
                </p>

                <Form onSubmit={handleUpdatePassword}>
                  <FormGroup>
                    <Label className="form-control-label font-weight-600" for="current-pwd">Current Password</Label>
                    <Input
                      required
                      id="current-pwd"
                      className="form-control-alternative rounded-3"
                      type="password"
                      placeholder="Enter Current Password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="form-control-label font-weight-600" for="new-pwd">New Password</Label>
                    <Input
                      required
                      id="new-pwd"
                      className="form-control-alternative rounded-3"
                      type="password"
                      placeholder="Enter New Password (min 6 chars)"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label className="form-control-label font-weight-600" for="confirm-pwd">Confirm New Password</Label>
                    <Input
                      required
                      id="confirm-pwd"
                      className="form-control-alternative rounded-3"
                      type="password"
                      placeholder="Confirm New Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </FormGroup>

                  <div className="text-right">
                    <Button color="primary" type="submit" className="rounded-pill px-5 shadow">
                      {passwordLoading ? (
                        <Spinner size="sm" />
                      ) : (
                        "Update Password"
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ChangePassword;
